import { IModelRaw } from './base';

export enum EMentorType {
  Touchstone = 'Touchstone',
  Speaker = 'Speaker',
  Other = 'Other',
}

export interface IMentor extends IModelRaw {
  name_en: string;

  name_vi: string;

  description_en?: string;

  description_vi?: string;

  title_en: string;
  company_en: string;

  title_vi: string;
  company_vi: string;

  photo_url?: string | null;

  priority?: number;

  type?: EMentorType;

  link?: string;
}
